<template>
    <b-card>

        <div class="position-relative table-responsive">
            <table class="table table-sm">
                <thead>
                    <tr>
                        <th>Navn</th>
                        <th>Værdi</th>
                        <th>Enhed</th>
                        <th></th>
                    </tr>
                </thead>

                <tr>
                    <td>
                        <FormGroup label="Attribut" rules="">
                            <template #input="{state}">
                                <v-select v-model="newItem.attribute" :options="attributes" @search="fetchAttributes" placeholder="Vælg attribut" :filterable="false" append-to-body>
                                    <template slot="option" slot-scope="option">
                                        {{ option.name }}
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        {{ option.name }}
                                    </template>
                                </v-select>
                            </template>
                        </FormGroup>
                    </td>
                    <td>
                        <FormGroup v-model="newItem.value" label="Værdi" rules=""></FormGroup>
                    </td>
                    <td>
                        <FormGroup v-model="newItem.unit" label="Enhed" rules=""></FormGroup>
                    </td>
                    <td class="text-right">
                        <b-button @click="addItem" variant="outline-success" class="py-3 px-2">
                            <feather-icon icon="PlusIcon" size="16" class="mx-6 my-2" />
                        </b-button>
                    </td>
                </tr>

                <draggable tag="tbody" v-model="items" class="cursor-move">
                    <tr v-for="(item, key) in items" :key="key + '-' + item.attributeId">
                        <td>
                            <FormGroup v-model="item.name" no-label rules=""></FormGroup>
                        </td>
                        <td>
                            <FormGroup v-model="item.value" no-label rules=""></FormGroup>
                        </td>
                        <td>
                            <FormGroup v-model="item.unit" no-label rules=""></FormGroup>
                        </td>
                        <td class="text-right">
                            <b-button @click="deleteItem(key)" variant="outline-danger" class="py-3 px-2 ml-7">
                                <feather-icon icon="TrashIcon" size="16" class="mx-6 my-2" />
                            </b-button>
                        </td>
                    </tr>
                </draggable>
            </table>

        </div>

    </b-card>

</template>

<script>
    export default {
        components: {},
        data: () => ({
            newItem: {
                value: 0,
                unit: null,
                attribute: null
            },
            attributes: []
        }),
        props: {
            value: null,
        },
        computed: {
            items: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('input', val)
                }
            }
        },
        created() {
            this.fetchAttributes("", () => { })
        },
        mounted() { },
        methods: {
            addItem() {
                this.items.push({
                    name: this.newItem.attribute.name,
                    attributeAlias: this.newItem.attribute.alias,
                    attributeId: this.newItem.attribute.id,
                    value: this.newItem.value,
                    unit: this.newItem.unit
                })

                this.newItem = {
                    value: 0,
                    unit: null,
                    attribute: null
                }
            },
            deleteItem(key) {
                this.item.splice(key, 1)
            },
            fetchAttributes(search, loading) {
                loading(true)

                this.$http.get("/api/attributes", {
                    params: {
                        search: search,
                        exclude: this.editing ? this.id : null
                    }
                }).then(x => {
                    this.attributes = x.data
                    loading(false)
                })
            },
        },
    }
</script>